import { IScheduledEventInfo } from 'src/types/scheduledEvent'
import { getHttp } from './apiLayer'

export const getScheduledEventInfo = async (eventId: string): Promise<IScheduledEventInfo> => {
  const result = await getHttp(`/events/${eventId}`)
  return result.data
}
